import { CaseProcessingTimeDescription } from '@/pages/ui/case-processing-time/case-processing-time-description/case-processing-time-description'
import { CaseProcessingTimeStatusText } from '@/pages/ui/case-processing-time/case-processing-time-status-text/case-processing-time-status-text'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/card/card'

import { type CaseInquiryIconType } from '@/lib/queries/types'
import { cn } from '@/lib/utils'

export interface ProcessingTimeCardProps {
  inquiryIcon?: CaseInquiryIconType
  inquiryText?: string
  estimatedTime?: number
  estimatedTimeUnit?: string
}

export const ProcessingTimeCard = ({
  inquiryIcon,
  inquiryText,
  estimatedTime,
  estimatedTimeUnit,
}: ProcessingTimeCardProps) => {
  return (
    <Card className={cn('h-full')}>
      <CardHeader>
        <CardTitle className={cn('text-lg font-semibold text-black')}>Case Processing Time</CardTitle>
      </CardHeader>
      <CardContent>
        {inquiryText && (
          <CaseProcessingTimeStatusText
            statusIconType={inquiryIcon ?? 1}
            statusText={inquiryText}
            classNames={cn('mb-3')}
          />
        )}

        <CaseProcessingTimeDescription
          estimatedTime={estimatedTime}
          unit={estimatedTimeUnit}
          className={{
            root: cn('flex flex-col items-center justify-center', 'px-3 py-[45px]'),
            titleText: cn('text-center text-base font-medium text-black'),
            valueText: cn('text-center text-3xl font-semibold text-black', 'mt-3'),
          }}
        />
      </CardContent>
    </Card>
  )
}
